import { render, staticRenderFns } from "./CalendarAddButton.vue?vue&type=template&id=4bdd59b2&"
import script from "./CalendarAddButton.vue?vue&type=script&lang=js&"
export * from "./CalendarAddButton.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAddButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports